import styled from 'styled-components'

import { Table as AntdTable } from 'src/components/Ant'

export const Div = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > div > div {
    margin-left: 1rem;
  }
`

export const Table = styled(AntdTable)`
  border-radius: 4px;
  margin: 12px 16px 24px 16px;
`
